import React, { useState } from 'react';
import SectionHeading from '../SectionHeading/SectionHeading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { useLanguage } from '../../contexts/LanguageContext';
import SpecialistsSlider from '../Slider/SpecialistsSlider';

const About = ({ data, teamData }) => {
  const { t } = useLanguage();
  const [showTeam, setShowTeam] = useState(false);

  const handleShowTeam = () => {
    const wasShowing = showTeam;
    setShowTeam(!showTeam);
    
    // Handle scroll behavior
    if (!wasShowing) {
      // Opening team section - scroll to team section
      setTimeout(() => {
        const teamSection = document.getElementById('team-section');
        if (teamSection) {
          const rect = teamSection.getBoundingClientRect();
          const scrollTop = window.pageYOffset + rect.top - 100; // 100px offset from top
          window.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        }
      }, 300); // Wait for animation to complete
    } else {
      // Closing team section - scroll back to about section
      setTimeout(() => {
        const aboutSection = document.getElementById('about');
        if (aboutSection) {
          const rect = aboutSection.getBoundingClientRect();
          const scrollTop = window.pageYOffset + rect.top - 50; // 50px offset from top
          window.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          });
        }
      }, 100);
    }
  };

  return (
    <section className="st-about-wrap" id="about">
      <div className="st-shape-bg">
        <img src="/shape/about-bg-shape.svg" alt="/shape/about-bg-shape.svg" />
      </div>
      <div className="st-height-b60 st-height-lg-b40" />
      <SectionHeading
        title={t('about.sectionTitle')}
        subTitle={t('about.sectionSubtitle')}
      />
      {/* <div className="container">
        <div className="row">
          <div className="col-lg-7">
            <div className="st-vertical-middle">
              <div className="st-vertical-middle-in">
                <div className="st-text-block st-style1">
                  <h2 className="st-text-block-title">{title}</h2>
                  <div className="st-height-b20 st-height-lg-b20" />
                  <div className="st-text-block-text">
                    <p>{parse(subTitle)}</p>
                  </div>
                  <div className="st-height-b25 st-height-lg-b25" />
                </div>
              </div>
            </div>
            <div className="st-height-b0 st-height-lg-b30" />
          </div>

          <div className="col-lg-5 wow fadeInRight" data-wow-duration="0.8s" data-wow-delay="0.2s">
            <div className="st-impact-wrap">
              <div className="st-impact">
                <h2 className="st-impact-title">{t('about.impactTitle')}</h2>
                <ul className="st-impact-list">
                  {highlights.map((highlight, index) => (
                    <li key={index}>
                      <div className="st-impact-text">{highlight.text}</div>
                    </li>
                  ))}
                </ul>
                <div className="st-height-b25 st-height-lg-b25" />
                <div className="st-call st-style1">
                  <div className="st-call-icon">
                    <a
                      href="https://wa.me/4915238556881"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faWhatsapp} style={{ color: '#26A69A', fontSize: '24px' }} />
                    </a>
                  </div>
                  <div className="st-call-text">
                    <div className="st-call-title">{t('about.getInTouch')}</div>
                    <div className="st-call-number">
                      <a
                        href="https://wa.me/4915238556881"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#26A69A', textDecoration: 'none' }}
                      >
                        +49 152 38556881
                      </a>
                    </div>
                  </div>
                </div>
                <div className="st-height-b25 st-height-lg-b25" />
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="st-meet-team-btn-wrapper">
                                <div className="st-call st-style1">
                  <div className="st-call-icon">
                    <a
                      href="https://wa.me/4915238556881"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FontAwesomeIcon icon={faWhatsapp} style={{ color: '#26A69A', fontSize: '24px' }} />
                    </a>
                  </div>
                  <div className="st-call-text">
                    <div className="st-call-title">{t('about.getInTouch')}</div>
                    <div className="st-call-number">
                      <a
                        href="https://wa.me/4915238556881"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#26A69A', textDecoration: 'none' }}
                      >
                        +49 152 38556881
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      {/* Centered Meet Our Team Button */}
      <div className="st-meet-team-btn-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="st-meet-team-btn-wrapper">
                <button
                  className="st-btn st-style1 st-color1 st-size-medium st-meet-team-btn"
                  onClick={handleShowTeam}
                >
                  <span className="st-btn-text">{showTeam ? t('about.showLess') : t('about.showMore')}</span>
                  <span className="st-btn-arrow">
                    {showTeam ? '▲' : '▼'}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Team Section - Shows when showTeam is true */}
      {showTeam && teamData && (
        <div id="team-section" className="st-team-section-wrapper">
          <div className="st-height-b30 st-height-lg-b20" />
          <SpecialistsSlider data={teamData} />
        </div>
      )}
    </section>
  );
};

export default About;